/**
 * Labstep
 */

import {
  Limits,
  type LimitTypes,
} from 'labstep-web/constants/limits';
import { selectAuthenticatedUserEntity } from 'labstep-web/state/selectors/authenticated-user';
import { useSelector } from 'react-redux';

export const useHasOrganization = (): boolean => {
  const hasOrganization = useSelector((state) => {
    const authenticatedUserEntity =
      selectAuthenticatedUserEntity(state);

    if (
      !authenticatedUserEntity ||
      !authenticatedUserEntity.user_organizations
    ) {
      return false;
    }
    return authenticatedUserEntity.user_organizations.length;
  });

  return !!hasOrganization;
};

export const useHasExceededLimit = (
  count: number,
  limitType: LimitTypes,
): boolean => {
  const hasExceeded = count >= Limits[limitType];

  // This check is added to prevent the upgrade modal from showing when the user has an organization
  const hasOrganization = useHasOrganization();

  return hasOrganization ? false : hasExceeded;
};
